import axios from "axios";
import { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { root_url } from "../../setting";
const AdminLogin = ({ history }) => {
  const [id, setId] = useState("");
  const [pw, setPw] = useState("");

  const onLogin = () => {
    axios
      .post(`${root_url}/api/admin/login`, { userName: id, password: pw })
      .then((res) => {
        console.log(res);
        localStorage.setItem("accessToken", res.data);
        history.push(`/admin/reception/summary`);
        // localStorage.setItem("accessToken");
      })
      .catch((e) => {
        if (e.response.status == 401)
          alert("아이디 혹은 비밀번호가 일치하지 않습니다. 다시 시도해주세요.");
      });
  };

  return (
    <Container className="p-5">
      <Row className="mt-5">
        <Col xs={12} md={12}>
          <Form
            style={{ margin: "0 auto", maxWidth: "400px" }}
            onSubmit={(e) => {
              e.preventDefault();
              onLogin();
            }}
          >
            <Form.Group className="mb-3" controlId="accountId">
              <Form.Label>아이디</Form.Label>
              <Form.Control
                type="text"
                placeholder="관리자 아이디"
                value={id}
                onChange={(e) => setId(e.target.value)}
              />
              <Form.Text className="text-muted">
                대청호관리자만 접속할 수 있으며, 허가되지 않은 사용자의 접속은
                형사상 책임이 부과됩니다.
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="accountPw">
              <Form.Label>암호</Form.Label>
              <Form.Control
                type="password"
                placeholder="비밀번호"
                value={pw}
                onChange={(e) => setPw(e.target.value)}
              />
            </Form.Group>
            <div style={{ maxWidth: "400px", margin: "0 auto" }}>
              <Button
                variant="primary"
                type="submit"
                className="me-4"
              >
                로그인
              </Button>
              <Button variant="success" type="button">
                홈으로
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminLogin;
